import { render, staticRenderFns } from "./PageCard.vue?vue&type=template&id=fa90c076"
import script from "./PageCard.vue?vue&type=script&lang=ts"
export * from "./PageCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports